import Ajax from "base/Ajax";
import { svg_include } from "base/functions";
import AjaxForm, { EVENT_ERROR, EVENT_SHOW_ERROR, EVENT_SUCCESS } from "webPage/AjaxForm";

export default class SimpleFormHandler {
    constructor($element, action, options = {}, hasUploader = false) {
        this.$element = $element;
        this.action = action;

        this.options = $.extend(true, {}, SimpleFormHandler.DEFAULT_SETTINGS, options);

        this.bindEvents();
    }

    bindEvents() {
        this.form = new AjaxForm(this.$element, ($form, formData) => {
            let submitData = formData;

            return Ajax.post("smartRota", this.action, submitData, Ajax.WEBSITE);
        });

        this.form.on(EVENT_SHOW_ERROR, (e) => {
            return e && e.data && e.data.exception && e.data.exception === "HttpValidationException";
        }).on(EVENT_SUCCESS, (data) => {
            this.$element.hide().parent('.js-modal-content').append([
                eotwJSXFactory('div', {className: "form-success"}, [
                    eotwJSXFactory('span', {className: "form-success__icon"}, [
                        eotwJSXFactory('lord-icon', {animation: "auto", src: "/images/lord-icons/183-envelope-mail-approved-outline-edited.json", target: "button"})
                    ]),
                    eotwJSXFactory('h2', {className: "heading heading--3"}, ["Thank you"]),
                    eotwJSXFactory('p', null, ["We’ll be in touch about your demo."]),
                    eotwJSXFactory('img', {height: "1", width: "1", style: "display:none;", alt: "", src: "https://px.ads.linkedin.com/collect/?pid=2545905&conversionId=2926001&fmt=gif"})
                ]),
            ]);
        }).on(EVENT_ERROR, (e) => {
            if (!(e && e.data && e.data.exception && e.data.exception === "HttpValidationException")) {
                this.$element.find('.js-form-overlay').addClass('modal-form__overlay--shown').html((
                    eotwJSXFactory('div', {className: "form-message"}, [
                        eotwJSXFactory('h2', {className: "heading heading--2"}, [this.options.messages.error.title]),
                        eotwJSXFactory('p', null, [e.message]),
                        eotwJSXFactory('button', {className: "btn btn--red js-try-again"}, [eotwJSXFactory('span', {className: "btn__text"}, ["Try again"])])
                    ])
                ));
            }
        });

        this.$element.on('click', '.js-try-again', () => {
            this.$element.find('.js-form-overlay').removeClass('modal-form__overlay--shown').html('');
        });
    }
}

SimpleFormHandler.DEFAULT_SETTINGS = {
    messages: {
        success: {
            icon: 'icon--message-success',
            title: 'Thank you for your message',
            text: 'Your message has been successfully sent. One of our team will be in touch with you soon.',
        },
        error: {
            icon: 'icon--message-error',
            title: 'There’s been a problem!',
        },
    },
};
